/**
 * Common Parking Detail Modal Component
 *
 * It includes a close button and integrates `ParkingDetailViewCommon` to show relevant parking information.
 * @param {Object} props - Props containing route, navigation, FontAwesomeIcon, and iconSize.
 */
import React from "react";
import { View, StyleSheet, TouchableOpacity, Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import ParkingDetailViewCommon from "../../views/Parking/DetailsView/ParkingDetailViewCommon";
import { COLORS, STRINGS } from "../../constants";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

const ParkingDetailModalCommon = ({ route, navigation, FontAwesomeIcon, closeBtnSize, iconSize }) => {
  const { index } = route.params;
  const insets = useSafeAreaInsets();

  return (
    <View style={[styles.modalContainer, Platform.OS === "android" ? { paddingTop: insets.top } : null]}>
      {/* Close Button */}
      <TouchableOpacity
        accessibilityLabel={`${STRINGS.close} ${STRINGS.parkingDetails}`}
        onPress={() => navigation.goBack()}
        style={styles.closeButton}
      >
        <FontAwesomeIcon icon={faCircleXmark} size={closeBtnSize} color={COLORS.border} />
      </TouchableOpacity>

      {/* Call Parking Details Component */}
      <ParkingDetailViewCommon route={{ params: { index } }} FontAwesomeIcon={FontAwesomeIcon} iconSize={iconSize} />
    </View>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    backgroundColor: COLORS.textLight,
    padding: 20,
  },
  closeButton: {
    alignSelf: "flex-end",
    padding: 16,
    paddingRight: 0,
  },
});

export default ParkingDetailModalCommon;
